import React from 'react'
import {ShoppingCart, Car, Globe, Wrench} from 'lucide-react'

export default function Services() {
  const services = [
    {
      icon: ShoppingCart,
      title: 'Achat véhicules neufs',
      description: 'Accédez aux véhicules neufs aux meilleurs prix grâce à notre réseau de concessionnaires partenaires',
      color: 'from-blue-600/20 to-blue-900/20',
      borderColor: 'border-blue-400/30',
      iconColor: 'text-blue-400'
    },
    {
      icon: Car,
      title: 'Véhicules d\'occasion',
      description: 'Large sélection de véhicules d\'occasion contrôlés et certifiés, garantie qualité',
      color: 'from-white/10 to-white/5',
      borderColor: 'border-white/20',
      iconColor: 'text-white'
    },
    {
      icon: Globe,
      title: 'Import international',
      description: 'Service d\'import de véhicules depuis l\'Europe, démarches administratives incluses',
      color: 'from-red-600/20 to-red-900/20',
      borderColor: 'border-red-400/30',
      iconColor: 'text-red-400'
    },
    {
      icon: Wrench,
      title: 'Reprise & financement',
      description: 'Reprise de votre ancien véhicule et solutions de financement sur mesure',
      color: 'from-blue-500/20 to-blue-600/20',
      borderColor: 'border-blue-300/30',
      iconColor: 'text-blue-300'
    }
  ]

  return (
    <section id="prestations" className="bg-black py-16 sm:py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 md:mb-20 animate-in fade-in slide-in-from-bottom-4 duration-700">
          <span className="text-blue-400 font-bold text-xs sm:text-sm uppercase tracking-widest mb-3 sm:mb-4 block">Nos prestations</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 sm:mb-6 px-4" style={{ fontFamily: 'Syne, sans-serif' }}>
            Services <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-red-500">complets</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/60 max-w-2xl mx-auto px-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            De l'achat à la livraison, nous gérons tout pour vous
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {services.map((service, idx) => (
            <div 
              key={idx}
              className={`group bg-gradient-to-br ${service.color} backdrop-blur-sm border ${service.borderColor} rounded-xl sm:rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-8 hover:scale-105 transition-all duration-500 hover:shadow-2xl animate-in fade-in slide-in-from-bottom-8 duration-700`}
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <service.icon className={`${service.iconColor} mb-4 sm:mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`} size={36} strokeWidth={1.5} />
              <h3 className="text-white font-bold text-base sm:text-lg md:text-xl mb-3 sm:mb-4 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>{service.title}</h3>
              <p className="text-white/70 text-xs sm:text-sm leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
